<template>
  <section>
    <div id="pagebutton">{{ deviceId }}</div>
    <pagebutton></pagebutton>
  </section>
</template>

<script>
import pagebutton from "./pagebutton.vue"; //
export default {
  data() {
    return { deviceId: "" };
  },
  components: { pagebutton },
  async created() {
    await this.getdeviceId();
    this.deviceId = await this.getdeviceId();
  },
  methods: {
    getdeviceId() {
      return new Promise(resolve => {
        let deviceId = "";
        this.setInterObj = window.setInterval(() => {
          try {
            /* eslint-disable no-undef */
            deviceId = api && api.deviceId;
          } catch (error) {
            console.warn(error);
          }
          if (deviceId.length > 0) {
            window.clearInterval(this.setInterObj);
            resolve(deviceId);
          }
        }, 1 * 1000);
      });
    }
  }
};
</script>
<style lang="less"></style>
